import React, { useCallback } from 'react'
import { Button, message, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { removeFile, uploadFile } from '../../../services/upload'

const API_URL = process.env.REACT_APP_API_URL

const InventoryActUpload = ({ docs = [], onDocListChange = () => {} }) => {
  const handleChange = useCallback(({ fileList: newFileList }) => {
    onDocListChange(
      newFileList.map((f) => ({
        ...f,
        url: f.xhr ? `${API_URL}${f.xhr[0]?.url}` : f.url,
        fileId: f.xhr ? f.xhr[0]?.id : f.fileId,
      }))
    )
  }, [])

  const onFileUpload = useCallback(async ({ onSuccess, onProgress, onError, file }, type) => {
    let formData = new FormData()

    formData.append('files', file, file.name)
    try {
      const response = await uploadFile({ data: formData })
      const data = response.data
      onSuccess(file, data)
    } catch (error) {
      message.error('Ошибка при загрузке файла')
      onError(error)
    }
  }, [])

  const onFileRemove = useCallback(async (file) => {
    const fileId = file?.xhr ? file?.xhr[0]?.id : file.fileId
    if (fileId) {
      await removeFile(fileId)
    } else {
      message.error('Ошибка при удалении файла')
      return Promise.reject('Empty file uid')
    }
  }, [])

  return (
    <Upload
      fileList={docs}
      onRemove={onFileRemove}
      customRequest={(e) => onFileUpload(e, 'final')}
      showUploadList={{ showRemoveIcon: true }}
      listType="text"
      onChange={handleChange}
    >
      <Button icon={<UploadOutlined />}>Загрузить подписанный акт</Button>
    </Upload>
  )
}

export default InventoryActUpload
